import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Area } from '../location/area';
import { AreaService } from '../location/area.service';
import { LocationService } from '../location/location.service';
import { LocationLogicService } from '../location/location-logic.service';
import { FormGroup } from '@angular/forms';

import { Message, ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css'],
  providers: [ConfirmationService]
})
export class AreaComponent implements OnInit {

  areaList: Area[];
  msgs: Message[];
  selectedArea: Area;
  formGroup: FormGroup;
  areaCntLocations: Map<number, number>;

  constructor(private areaService: AreaService, private router: Router,
    private confirmationService: ConfirmationService,
    private locationService: LocationService,
    private locationLogicService: LocationLogicService) {
    this.areaList = [];
    this.msgs = [];
    this.selectedArea = new Area();
    this.areaCntLocations = new Map<number, number>();
  }

  ngOnInit() {
    this.loadAreas();
  }

  private loadAreas() {
    this.areaService.list().subscribe(
      (areaArray: Area[]) => {
        this.areaList = [];
        for (var area of areaArray) {
          this.areaList = [...this.areaList, area];
          /* Request the number of locations in area */
          this.locationService.cntLocations(area.id).subscribe(
            (cnt: any) => {
              this.areaCntLocations[cnt.areaid] = cnt.count;
            }
          );
        }
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of areas.' });
      }
    );
  }

  /**
   * Create a new instance of area and add it to list of areas.
   * After that, the new instance is set as selected area.
   */
  public addNew() {
    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.areaList) {
      if (a.id < 0) {
        this.selectedArea = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Lagerbereich speichern..' });
        return;
      }
    }

    let area = new Area();
    area.id = -1;
    area.created = new Date();
    area.updated = new Date();

    this.areaList = [...this.areaList, area];
    this.selectedArea = area;
  }

  /**
   * sets selected area
   * @param area 
   */
  public selectArea(pArea: Area) {
    this.selectedArea = pArea;
  }

  public showLoctionsOfArea(pArea: Area) {
    console.log('Go to location list of area: ' + pArea.id);
    this.selectedArea = pArea;
    this.router.navigate(["area", "locations", this.selectedArea.id]);
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    //TODO
  }

  /**
   * Saves or updates edited area entity to server.
   */
  public onSave() {
    if (this.selectedArea == null || this.selectedArea.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an area first.' });

    // Test barcode format if it is valid
    if (!this.locationLogicService.isLocationFormatValid(this.selectedArea.barcodeformat)) {
      this.msgs.push({ severity: 'error', summary: 'Barcodeformat muss mindest einen Platzhalter enthalten.' });
      return;
    }

    if (this.selectedArea.id == -1) {
      this.areaService.save(this.selectedArea).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lagerberich wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadAreas();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lagerbereich konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save customer, error msg: ' + err);
        }
      );
    }
    else {
      this.areaService.update(this.selectedArea).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lagerberich wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadAreas();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lagerbereich konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save customer, error msg: ' + err);
        }
      );
    }
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedArea == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Lagerbereich ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Lagerbereich wirlich loeschen?',
      accept: () => {
        if (this.selectedArea.id == -1) {
          // we are dealing with an unsaved entity which only has to be removed from gui
          let tmpList: Area[] = [];
          for (var a of this.areaList) {
            if (a.id != -1)
              tmpList = [...tmpList, a];
          }
          this.areaList = tmpList;
          return;
        }

        this.areaService.delete(this.selectedArea.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Lagerbereich wurde geloescht.' });
              this.loadAreas();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Lagerbereich konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Lagerbereich konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/area/area.component.ts